<template>
    <div>
        <div class="header">
            <el-button
                    @click="submitForm('infoConfigForm')"
                    size="small"
                    type="primary">保存
            </el-button>
        </div>
        <el-form
                ref="infoConfigForm"
                :model="form"
                :rules="rules"
                class="form"
                size="medium"
                label-width="130px">
            <el-form-item label="支付渠道名称：" prop="channelName">
                <el-input placeholder="请输入" v-model="form.channelName"/>
            </el-form-item>
            <el-form-item label="联系方式：" prop="contactAccount">
                <el-input placeholder="请输入" v-model="form.contactAccount"/>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        props: {
            info: Object
        },
        data() {
            return {
                form: {
                    id:'',
                    channelName: '',
                    contactAccount: '',
                },
                rules: {
                    channelName: [
                        {required: true, message: '请输入支付渠道名称', trigger: 'blur'}
                    ]
                }
            }
        },
        watch:{
            info(){
                this.form = {
                    id: this.info.id,
                    channelName: this.info.name,
                    contactAccount:this.info.contactAccount
                }
            }
        },
        methods: {
            ...mapActions('payChannel', ['getChannelPaymentQuery', 'updateChannelInfo']),
            clearForm() {
                this.$refs['infoConfigForm'].resetFields();
            },
            // 保存充值配置
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.updateChannelInfo(this.form).then(() => {
                            this.$message.success('保存成功');
                            this.$emit('my-submit',this.form)
                        })
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        display: flex;
        justify-content: flex-end;
        padding-left: 5px;
    }

    .form {
        width: 500px;
        padding-right: 30px;
        margin: 80px auto 0;
    }
</style>




